import * as React from 'react'
import { designTokens } from '../../lib/design-tokens'

type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string
  strokeWidth?: string | number
}

export const HomeIcon = ({
  width = 24,
  height = 24,
  color = designTokens.colors.text.primary,
  strokeWidth = designTokens.borders.widths.advertisingCardIconMobile,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20.5 20.4037"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M0.75 9.09211C0.75 7.86792 1.31058 6.71114 2.27142 5.95258L7.77142 1.61047C9.22466 0.463176 11.2753 0.463178 12.7286 1.61047L18.2286 5.95258C19.1894 6.71114 19.75 7.86792 19.75 9.09211V15.6537C19.75 17.8628 17.9591 19.6537 15.75 19.6537H14.25C13.6977 19.6537 13.25 19.206 13.25 18.6537V15.6537C13.25 14.5491 12.3546 13.6537 11.25 13.6537H9.25C8.14543 13.6537 7.25 14.5491 7.25 15.6537V18.6537C7.25 19.206 6.80228 19.6537 6.25 19.6537H4.75C2.54086 19.6537 0.75 17.8628 0.75 15.6537L0.75 9.09211Z"
      stroke={color}
      strokeWidth={strokeWidth}
    />
  </svg>
)

HomeIcon.displayName = 'HomeIcon'
